module.exports = __webpack_public_path__ + "img/big-picture-thinker.3fd7b739.svg";